module.exports = __webpack_public_path__ + "img/sample.d7918b50.png";